import React from "react";
// import { connect } from "react-redux";
import "../assets/css/main.css"
// import "../css/main.css"
import cityIcon from "../images/city-icon.png"
import boardIcon from "../images/board-icon.png"
import userIcon from "../images/user-icon.png"
class Counter extends React.Component {
    render() {
        return (
            <React.Fragment>
                <section className="counter-section gradient-bg ptb-40">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-4">
                                <div className="text-white p-2 count-data text-center my-3">
                                    <img src={cityIcon} alt="" />
                                    <h3 className="mt-2 mb-1 text-white font-weight-bolder">1,100</h3>
                                    <span>Cities</span>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-4">
                                <div className="text-white p-2 count-data text-center my-3">
                                    <img src={boardIcon} alt="" />
                                    <h3 className="mt-2 mb-1 text-white font-weight-bolder">50,000</h3>
                                    <span>Teachers</span>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-4">
                                <div className="text-white p-2 count-data text-center my-3">
                                    <img src={userIcon} alt="" />
                                    <h3 className="mt-2 mb-1 text-white font-weight-bolder">70 Lakh</h3>
                                    <span>Students</span>
                                </div>
                            </div>
                            {/* <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="text-white p-2 count-data text-center my-3">
                            <span className="fas fa-mug-hot icon-size-lg mb-2"></span>
                            <h3 className="count-number mb-1 text-white font-weight-bolder">2323</h3>
                            <span>Cup of Coffee</span>
                        </div>
                    </div> */}
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default Counter;
